import FullWidthBarBreadcrumbs from '@/components/Breadcrumb/FullWidthBarBreadcrumbs';
import CenteredContentSection from '@/components/ContentSection/CenteredContentSection';
import { H3 } from '@/components/Element/Heading';
import MetaTags from '@/components/Head/MetaTags';
import IncentiveTable from '@/components/IncentiveTable/IncentiveTable';
// import { InstallerTable } from '@/components/InstallerTable/InstallerTable';
import FullWidthStateForm from '@/components/LeadForm/FullWidthStateForm';
import PurchaseOptionSection from '@/components/PurchaseOptionSection/PurchaseOptionSection';
import StatSection from '@/components/StatSection.tsx/StatSection';
import StateFAQ from '@/components/StateFAQ/StateFAQ';
import StateHeaderSection from '@/components/StateHeaderSection/StateHeaderSection';
import TableOfContents from '@/components/TableOfContents/TableOfContents';
// import { TopCardInstallerContainer } from '@/components/TopCard/TopCardInstallerContainer';
// import {
//   BlueRavenCard,
//   SunPowerCard,
//   TitanCard,
//   Top3OHInstallers,
// } from 'data/static';
import React from 'react';

const Page = () => {
  const incentives = [
    {
      incentive: 'Federal ITC - 30%',
      value:
        "Solar PV systems installed in 2022 - 2032 are eligible for a 30% tax credit. The credit can only be claimed by on the original installation of the solar equipment located at a residence of yours. You must also purchase it using cash or financing, but you're not leasing the system or paying a solar company for the electricity produced by the system.",
    },
    {
      incentive: 'Instant Rebate from EnergyPal',
      value:
        'EnergyPal secures group discounts by leveraging the depth of our network. We pass these savings onto homeowners every day!',
    },
    {
      incentive: 'Net Metering',
      value:
        "Ohio's net metering policy allows solar producers to sell their surplus energy back to the grid, earning credits on their electricity bills. These credits are granted at the full retail rate set by the utility.",
    },
    {
      incentive: 'Solar Renewable Energy Credits (SRECs)',
      value:
        'Solar producers in Ohio are eligible to receive Solar Renewable Energy Credits (SRECs), earning one SREC for each megawatt-hour (MWh) of power generated. SRECs offer a valuable income stream for residential solar system owners. The value of each SREC in Ohio varies based on prevailing market conditions.',
    },
    {
      incentive: 'Qualified Energy Project Tax Exemption',
      value:
        'Through the Qualified Energy Project Tax Exemption, solar producers are granted an exemption from personal property tax imposed by public utilities. To qualify, you need to complete an application and secure approval from the state.',
    },
    {
      incentive: 'Energy Conservation for Ohioans (ECO-Link)',
      value:
        'Program Ohio homeowners can access affordable solar financing via the ECO-Link program. Solar loans of up to $50,000 are eligible for a 3% interest rate reduction. Specific eligibility criteria and restrictions should be reviewed prior to applying.',
    },
  ];
  const sections = [
    // {
    //   name: 'Ohio Installer Comparison',
    //   id: 'compare-installers',
    // },

    // {
    //   name: 'Best Solar Panel Installers in Ohio',
    //   id: 'best-installers',
    // },
    {
      name: 'Incentives, Tax Credits, And Rebates in Ohio',
      id: 'incentives',
    },
    {
      name: 'Home Solar Financing in Ohio',
      id: 'financing',
    },

    {
      name: 'Frequently Asked Questions',
      id: 'faq',
    },
  ];
  // const TopInstallers = [SunPowerCard, TitanCard, BlueRavenCard];

  return (
    <article>
      <MetaTags
        title="Ohio's Home Solar Benefits: Incentives, Credits & Policies"
        description="Find available incentives, tax credits, and utility policies for home solar in Ohio with EnergyPal. Switch to solar energy today and save."
      />
      <StateHeaderSection dark state="Ohio" />
      <StatSection stats={'Ohio'} />
      <FullWidthBarBreadcrumbs
        pages={[
          {
            name: 'Home Solar & Battery Installers Near Me',
            href: '/home-battery-solar-installers-near-me',
          },
          {
            name: 'Ohio Solar',
            href: '/home-battery-solar-installers-near-me/oh-ohio',
          },
        ]}
      />
      <CenteredContentSection>
        <H3>Ohio Solar</H3>
        <p>
          Solar energy has been steadily gaining ground in Ohio, with a growing
          emphasis on local incentives to drive its adoption. The state&apos;s
          diverse geography, from urban centers to rural landscapes, offers
          ample potential for solar power generation. Ohio&apos;s commitment to
          renewable energy is reflected in its efforts to promote solar
          installations through various local incentives, fostering a
          sustainable energy future.
        </p>
        <p>
          Net metering, the SREC program, and property tax exemptions all play
          pivotal roles in driving the growth of solar energy within the state.
          These incentives not only contribute to cleaner energy but also
          enhance economic development and create opportunities for innovation
          in Ohio&apos;s solar industry.
        </p>
        <p>
          Local incentives such as the Renewable Energy Standard, net metering,
          tax credits, and community solar programs have all played a vital role
          in promoting solar adoption. These incentives not only contribute to a
          cleaner environment but also stimulate economic growth, job creation,
          and technological innovation within the state&apos;s solar industry.
        </p>
        <p>
          Let’s learn about home solar incentives, the utility policies
          associated with interconnection and setup, and solar financing plans
          for solar panels and battery systems in Ohio.
        </p>
        <TableOfContents sections={sections} />
        {/* <H3 id="compare-installers">Top 3 Installers in Ohio</H3>
        <InstallerTable companies={Top3OHInstallers} /> */}
      </CenteredContentSection>
      {/* <div id="best-installers">
        <TopCardInstallerContainer installerTopCards={TopInstallers} />
      </div> */}
      <CenteredContentSection>
        <h4
          className="text-4xl font-semibold text-center text-black mt-0"
          id="incentives"
        >
          Incentive Programs, Tax Credits, and
        </h4>
        <h4 className="text-4xl font-semibold text-center text-black mb-6">
          Solar Rebates in Ohio
        </h4>
        <IncentiveTable
          heading1={'Incentive'}
          heading2={'Description'}
          data={incentives}
        />
        <FullWidthStateForm cid="9cm7oaq5j1unket1" state="Ohio" />

        <H3>Other Solar Energy Incentives</H3>
        <p>
          The US federal government helps residents and businesses pay for their
          solar systems. The federal investment tax credit (ITC) allows for a
          tax deduction of 30% of the cost of a solar system currently. Tax
          credits can be rolled over if you can&rsquo;t use the whole credit
          this year. The ITC cannot be claimed for solar leases or power
          purchase agreements (PPAs) where the third party financier takes the
          credits themselves, but that is typically baked into a reduced
          lease/PPA monthly for you.
        </p>
        <p>
          If you purchased a $20,000 system, your savings from the federal tax
          credit would look like this:
        </p>
        <p>
          <em>$20,000 X 0.30 = $6,000 savings</em>
        </p>
        <div id="financing">
          <PurchaseOptionSection cid="9cm7oaq5j1unket1" state="Ohio" />
        </div>
        <div id="faq">
          <StateFAQ state="Ohio" />
        </div>
      </CenteredContentSection>
    </article>
  );
};

export default Page;
